import { SelloutProductColor } from '../../../../../../../../services/modules/product-color-sellout/product-color-sellout.types';
import { GridItemSkuIdsErrorAndDisabled } from '../../../types/OrderProductGridContext.types';

export const getAvailableSelloutMetrics = (
  gridItemSkuIdsErrorAndDisabled: GridItemSkuIdsErrorAndDisabled[],
  selloutMetrics: SelloutProductColor,
): SelloutProductColor => {
  const disabledMap = new Map(
    gridItemSkuIdsErrorAndDisabled.map((item) => [item.skuId, item.disabled]),
  );

  const { availableSkus, unavailableSkusQuantitySold } = selloutMetrics.skus.reduce(
    (acc, sku) => {
      const isDisabled = disabledMap.get(sku.id);

      if (isDisabled) {
        acc.unavailableSkusQuantitySold += sku.sold ?? 0;
      } else {
        acc.availableSkus.push(sku);
      }

      return acc;
    },
    {
      availableSkus: [] as SelloutProductColor['skus'],
      unavailableSkusQuantitySold: 0,
    },
  );

  return {
    ...selloutMetrics,
    skus: availableSkus,
    totalSold: selloutMetrics.totalSold - unavailableSkusQuantitySold,
  };
};
